module.exports = __webpack_public_path__ + "img/ad-icon.c84c40ea.jpg";